import { useGetLeaderboardDataQuery } from '~/Leaderboard/apis/leaderboard-api'
import { LeagueType } from '~/Leaderboard/types/leaderboard.types'
import { getUserCurrentRank } from '~/Leaderboard/utils/utils'
import { isAuthenticated } from '~/auth/slices/auth.slice'
import { useAppSelector } from '~/redux/hooks'

import useCurrentUser from './useCurrentUser'

export function useGetLeagueInfoForNav(): {
  leagueIconUrl: string
  leagueBadgeIconUrl: string
  currentLeague: number
  userCurrentRank: number
} {
  const authenticated = useAppSelector(isAuthenticated)
  const user = useCurrentUser()
  const leaderboardData = useGetLeaderboardDataQuery(undefined, { skip: !authenticated })
  const userId = user?.id || -1
  const currentLeagueUsers = leaderboardData.data?.users || []
  const currentLeague: number =
    leaderboardData.data?.currentLeague && leaderboardData.data?.currentLeague !== 0
      ? leaderboardData.data?.currentLeague
      : 1
  const currentLeagueName: string = LeagueType[currentLeague].toLowerCase()
  // -nav-badge assets are empty shields (bottom nav); -badge.svg has the House of Math "H" letterform (topbar)
  const leagueIconUrl: string = `gamification/badges/league/${currentLeagueName}-nav-badge.${
    currentLeague === 5 ? 'svg' : 'png'
  }`
  const leagueBadgeIconUrl: string = `gamification/badges/league/${currentLeagueName}-badge.svg`
  const userCurrentRank: number = getUserCurrentRank(userId, currentLeagueUsers)

  return { leagueIconUrl, leagueBadgeIconUrl, currentLeague, userCurrentRank }
}

export function useGetBadgeGradient(leagueNumber: LeagueType | undefined): string {
  switch (leagueNumber) {
    case LeagueType.BRONZE:
      return 'bg-badge-bronze'
    case LeagueType.SILVER:
      return 'bg-badge-silver'
    case LeagueType.GOLD:
      return 'bg-badge-gold'
    case LeagueType.PLATINUM:
      return 'bg-badge-platinum'
    case LeagueType.DIAMOND:
      return 'bg-badge-diamond'
    default:
      return ''
  }
}
